var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-card__title"},[_c('v-spacer'),_c('botao-avancar-salvar-itens',{attrs:{"deveHabilitarBotoes":_vm.deveHabilitarBotoes},on:{"savlarItensEAvancar":function($event){return _vm.$emit('savlarItensEAvancar')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }